import React from 'react';
import {
  patientAccessTheme,
  Typography,
} from '@HomaHealth/ui-component-library';
import HistoricNoData from '../../atoms/Icons/historicNoData';
import { Grid } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

interface NoHistoricDataProps {
  title: string;
}
const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const NoHistoricData: React.FC<NoHistoricDataProps> = ({ title }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.mainContainer}>
      <HistoricNoData />
      <Typography
        textColor={patientAccessTheme.palette.text.lowemphasis}
        fontSize="12px"
      >
        {title}
      </Typography>
    </Grid>
  );
};

export default NoHistoricData;
